export default __webpack_public_path__ + "static/media/Group 490.2de74ebe.png";